export const REQUEST_OPEN_SLIDE_OVER = 'REQUEST_OPEN_SLIDE_OVER';
export const REQUEST_CLOSE_SLIDE_OVER = 'REQUEST_CLOSE_SLIDE_OVER';
